import apiClient from "./apiClient";

/**
 * @param {object} opts
 * @param {number} [opts.page]
 * @param {number} [opts.pageSize]
 * @param {string} [opts.search]
 * @param {boolean} [opts.activeOnly]
 * @param {number|null} [tenantId] platform admin context
 */
export async function listMedicineProducts(
  {
    page = 1,
    pageSize = 10,
    search,
    activeOnly = false,
  } = {},
  tenantId = null
) {
  const params = { page, page_size: pageSize, active_only: activeOnly };
  if (search?.trim()) params.search = search.trim();
  if (tenantId != null) params.tenant_id = tenantId;
  const res = await apiClient.get("/medicine/products", { params });
  return res.data;
}

/**
 * @param {object} body MedicineProductCreate
 * @param {number|null} tenantId
 */
export async function createMedicineProduct(body, tenantId = null) {
  const config = {};
  if (tenantId != null) config.params = { tenant_id: tenantId };
  const res = await apiClient.post("/medicine/products", body, config);
  return res.data;
}

/**
 * @param {number} productId
 * @param {object} body MedicineProductUpdate
 * @param {number|null} tenantId
 */
export async function updateMedicineProduct(productId, body, tenantId = null) {
  const config = {};
  if (tenantId != null) config.params = { tenant_id: tenantId };
  const res = await apiClient.put(
    `/medicine/products/${productId}`,
    body,
    config
  );
  return res.data;
}

/**
 * @param {object} opts
 * @param {number} [opts.page]
 * @param {number} [opts.pageSize]
 * @param {number} [opts.productId]
 * @param {number|null} [tenantId]
 */
export async function listMedicineLots(
  { page = 1, pageSize = 10, productId } = {},
  tenantId = null
) {
  const params = { page, page_size: pageSize };
  if (productId != null) params.product_id = productId;
  if (tenantId != null) params.tenant_id = tenantId;
  const res = await apiClient.get("/medicine/lots", { params });
  return res.data;
}

/**
 * @param {object} body MedicineLotCreate
 * @param {number|null} tenantId
 */
export async function createMedicineLot(body, tenantId = null) {
  const config = {};
  if (tenantId != null) config.params = { tenant_id: tenantId };
  const res = await apiClient.post("/medicine/lots", body, config);
  return res.data;
}

/**
 * @param {number} lotId
 * @param {object} body MedicineLotUpdate
 * @param {number|null} tenantId
 */
export async function updateMedicineLot(lotId, body, tenantId = null) {
  const config = {};
  if (tenantId != null) config.params = { tenant_id: tenantId };
  const res = await apiClient.put(`/medicine/lots/${lotId}`, body, config);
  return res.data;
}
